var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinemas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 30C4.9 30 3.95867 29.6087 3.176 28.826C2.39333 28.0433 2.00133 27.1013 2 26V4C2 2.9 2.392 1.95867 3.176 1.176C3.96 0.393333 4.90133 0.00133333 6 0H38C39.1 0 40.042 0.392 40.826 1.176C41.61 1.96 42.0013 2.90133 42 4V26C42 27.1 41.6087 28.042 40.826 28.826C40.0433 29.61 39.1013 30.0013 38 30H6ZM0 36V32H44V36H0Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinemas);
export default __webpack_public_path__ + "static/media/cinemas.922440e92739af2e1620580c0ebe4d87.svg";
export { ForwardRef as ReactComponent };